/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const onNextFrame = (cb) => {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => cb());
    });
};
const transitionAttribute = 'data-starc-no-transition';
export const disableTransitions = () => {
    document.body.setAttribute(transitionAttribute, 'true');
};
export const enableTransitions = () => {
    document.body.removeAttribute(transitionAttribute);
};
export const checkTransitions = () => {
    return !document.body.hasAttribute(transitionAttribute);
};
